<template>
  <div>
    <div v-if="video.storage_type">
      <div v-if="video.video_file_url.includes('player.vimeo.com')" class="vimeo-container">
        <iframe class="border-0" :src="video.video_file_url" allowfullscreen />
        <div v-if="canEditVimeo" class="d-flex justify-content-center align-items-center mt-1">
          <router-link :to="{ name: 'vimeo-edit', params: { id: video.id }}">
            <i v-b-tooltip.hover.top="'Edit Vimeo CC'" class="fas fa-video custom-fa-edit-color">
              <span class="regular-14 ml-1 custom-fa-edit-color">Edit Vimeo CC</span>
            </i>
          </router-link>
        </div>
      </div>
      <div v-else>
        <video
          v-if="['filesystem', 'upload_s3', 's3'].includes(video.storage_type)"
          controls
          width="260"
          height="150"
          @play="handlePlay"
        >
          <source :src="video.video_file_url" type="video/mp4">
        </video>
        <iframe
          v-else
          class="border-0"
          :src="video.video_file_url"
          allowfullscreen
        />
      </div>
    </div>
    <iframe
      v-else
      class="border-0"
      :src="video.video_file_url"
      allowfullscreen
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: "VideoViewSection",
	props: ["video"],
	data() {
		return {
			firstPlay: true,
		}
	},
	computed: {
		...mapGetters(["canEditVimeo"]),
	},
	methods: {
		handlePlay() {
			if (this.firstPlay) {
				this.convertToVimeo()
				this.firstPlay = false
			}
		},
		async convertToVimeo() {
			if (this.video.vimeo_convert_status == null) {
				this.video.vimeo_convert_status = "in_progress"
				await this.$http.post(`${process.env.VUE_APP_API_URL}/videos/convert_to_vimeo`, {
					asset_video_id: this.video.id,
					video_url: this.video.video_file_url,
				})
			}
		},
	},
}
</script>

<style scoped>
  .vimeo-edit-icon {
    display: none;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    padding: 8px;
    right: 0;
  }
  .vimeo-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .vimeo-container:hover .vimeo-edit-icon {
    display: flex;
  }
</style>
